import { IChecklistField } from '../../../models/Checklist'
import {
  AUTOCOMPLETE_CONTROL_TYPES,
  AutoCompleteFieldName,
  IAutoCompleteControlsProps
} from '../../form_controls/AutoCompleteControls'
import { ICanvasControlProps } from '../../form_controls/CanvasControl'
import { IFormulaControlProps } from '../../form_controls/FormulaControl'
import { ISelectControlProps } from '../../form_controls/SelectControl'
import { IDataGridControlProps } from '../../form_controls/grids/DataGridControl'
import { IControlProps } from '../../form_controls/types'

export const selectPropsConverter = (
  field: IChecklistField,
  props: ISelectControlProps | IAutoCompleteControlsProps
) => {
  props.options = field.options!
  props.colourRules = field.importanceAnswerColorRules
  if (
    AUTOCOMPLETE_CONTROL_TYPES.includes(
      field.mappingField?.value as AutoCompleteFieldName
    )
  ) {
    ;(props as IAutoCompleteControlsProps).offline = field.offline ?? false
  }
}

export const propConverters: {
  [fieldType: string]: (field: IChecklistField, props: any) => void
} = {
  placeholder: selectPropsConverter,
  select: selectPropsConverter,
  yesno: selectPropsConverter,
  checkbox: (field, props: IControlProps) => {
    props.colourRules = field.importanceAnswerColorRules
  },
  number: (field, props: IControlProps) => {
    props.colourRules = field.importanceAnswerColorRules
  },
  select_many: (field, props: ISelectControlProps) => {
    props.options = field.options!
  },
  datagrid: (field, props: IDataGridControlProps) => {
    props.dataGrid = field.dataGrid!
  },
  formula: (field, props: IFormulaControlProps) => {
    props.formula = field.formula!
  },
  photo: (field, props: ICanvasControlProps) => {
    props.photoData = field.photoData!
  }
}

// TODO: We should have integration tests over this

export function fieldToControlProps(field: IChecklistField, propsObj: any) {
  if (field.type in propConverters) {
    propConverters[field.type](field, propsObj)
  }
}
